<template lang="pug">
shListData(title="Sets" resolver="sets" keyData="id" component="shSet")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Sets',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/set/Sets.vue